import { roundNumber } from "./number";

export const sizeDpr = (): { width: number; height: number } => {
	const width: number = window.innerWidth;
	const height: number = window.innerHeight;
	let dpr: number = window.devicePixelRatio;
	if (dpr > 2.0) {
		dpr = 2.0;
	}
	const widthDPR: number = roundNumber(width * dpr);
	const heightDPR: number = roundNumber(height * dpr);

	return { width: widthDPR, height: heightDPR };
};
